import { APIWorker } from "./Worker"

export interface APIWorkerGroup {
    id: number
    name: string
    workers: APIWorker[]
    created: string
    ownerId: number
}

export function getWorkerGroupId(group: APIWorkerGroup): string {
    return String(group.id)
}

export function toDisplayText(group: APIWorkerGroup): string {
    return group.name
}

export function getNumericWorkerGroupId(group: APIWorkerGroup): number {
    return group.id
}
